/**
 * Initializes the cookie settings button to trigger
 * the Cookiebot consent renewal dialog.
 */
export const initCookieSettings = () => {
  const button = document.getElementById('cookie-settings-button');
  if (!button) return;

  button.addEventListener('click', () => {
    if (globalThis.Cookiebot) {
      globalThis.Cookiebot.renew();
    }
  });
};
